module.exports = __webpack_public_path__ + "img/Character_Bennett_Thumb.309aa18c.png";